// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"237":"7b4ee5b1","312":"7b4ee5b1","428":"7b4ee5b1","569":"7b4ee5b1","836":"7b4ee5b1","852":"7b4ee5b1","904":"7b4ee5b1","928":"7b4ee5b1"}[chunkId] + ".chunk.css";
};